export const FEATURES = [
  {
    title: 'Watch real <br>customer reviews',
    description:
      "Scroll through real customers' video reviews of products they've shopped on the Flip app",
    image: 'home-section-2/section2-phone1.png',
  },
  {
    title: 'Shop ethically sourced, <br>inclusive brands',
    description:
      'Shop from a variety of brands that are ethically sourced, inclusive, cruelty-free and vegan',
    image: 'home-section-2/section2-phone2.png',
    imageWidth: 285,
  },
  {
    title: 'Enjoy free shipping <br>& easy returns',
    description:
      'Enjoy same day shipping. To make a return, stick the provided label on the box and schedule a pickup on the Flip App',
    image: 'home-section-2/section2-phone3.png',
    imageWidth: 252,
  },
  {
    title: 'Share your own <br>reviews',
    description:
      'Be part of the Flip community. Share your own opinions and review the products you receive in your Flip box',
    image: 'home-section-2/section2-phone4.png',
  },
  {
    title: 'Watch live <br>shopping shows',
    description:
      'Watch brand founders and experts review products, answer questions, and announce exclusive deals on live shopping shows',
    image: 'home-section-2/section2-phone5.png',
  },
  {
    title: 'Vote & earn <br>shopping rewards',
    description:
      'As you scroll through the Flip feed, swipe right or left to vote for other shoppers and earn shopping rewards for every vote\n',
    image: 'home-section-2/section2-phone6.png',
    imageWidth: 270,
  },
]
